export const EditorOption = {
    formats: [
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'strike',
        'color',
        'background',
        'header',
        'list',
        'bullet',
        'indent',
        'align',
        'link',
    ],
    modules: {
        toolbar: [
            [{ font: [] }],
            [{ size: [] }],

            ['bold', 'italic', 'underline', 'strike'],

            [{ color: [] }, { background: [] }], // 🎨 COLOR OPTIONS

            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],

            [{ align: [] }],

            ['link'],
            ['clean']
        ]
    }
}